import { useMemo, useSyncExternalStore } from 'react';
import { boardCamera } from '@chessmate/board-3d';

const QUERY = '(max-width: 639px)';

function subscribe(cb: () => void): () => void {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return () => {};
  const mq = window.matchMedia(QUERY);
  mq.addEventListener('change', cb);
  return () => mq.removeEventListener('change', cb);
}
const snapshot = (): boolean => typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia(QUERY).matches;

/** True below 640px: the phone layout (near top-down board, folded-away secondary controls). */
export function usePhone(): boolean {
  return useSyncExternalStore(subscribe, snapshot, () => false);
}

/** The `<Canvas camera>` prop for a playable board: near top-down on a phone, a flatter 3D pitch elsewhere. */
export function useBoardCamera(game: 'chess' | 'backgammon' = 'chess') {
  const phone = usePhone();
  return useMemo(() => {
    const c = boardCamera(phone, game);
    return { position: [...c.position] as [number, number, number], fov: c.fov };
  }, [phone, game]);
}
